import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { take, timer } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-ui-callout-message',
  templateUrl: './ui-callout-message.component.html',
  styleUrls: ['./ui-callout-message.component.scss'],
})
export class UiCalloutMessageComponent implements OnInit {
  @Input() header?: string;
  @Input() message!: string;
  @Input() icon?: string;
  @Input() type: 'success' | 'error' = 'success';
  @Input() timeout?: number;
  @Input() closeable = false;

  @Output() closed = new EventEmitter();

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (this.timeout) {
      timer(this.timeout * 1000)
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe(_ => this.closed.emit());
    }
  }
}
